<template>
  <div class="label">
    <div class="lable_column" v-for="(subList, i) in keywords" :key="i">
      <div class="title">{{ subList.name }}：</div>
      <ul>
        <li
          v-for="(item, i) in subList.menuList"
          :key="i"
          @click="categorySearchItemClick(subList.name, item)"
          :class="{ select: item.isActive }"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "categorySearchCom",
  props: {
    categorySearchData: Array,
  },
  watch: {
    categorySearchData: function () {
      this.keywords = this.categorySearchData;
    },
  },
  data() {
    return {
      keywords: [],
    };
  },
  methods: {
    categorySearchItemClick(listName, item) {
      let resetKeyword = false;
      if (listName === "关键字" && item.name === "全部") {
        resetKeyword = true;
      }
      this.keywords.forEach((x) => {
        if (x.name == listName) {
          x.menuList.forEach((d) => {
            if (d.searchField == item.searchField) {
              d.isActive = !x.isActive;
            } else {
              d.isActive = false;
            }
          });
        }
      });
      var queryParams = {};
      // let paramsArr = []
      let keyword;
      this.keywords.forEach((x) => {
        if (x.name === "关键字") {
          x.menuList.map((item) => {
            if (item.isActive && typeof item.searchField === "string") {
              keyword = JSON.parse(item.searchField);
            }
          });
          return;
        }
        x.menuList.forEach((d) => {
          if (d.isActive && typeof d.searchField === "string") {
            try {
              Object.assign(queryParams, JSON.parse(d.searchField));
            } catch (ignore) {
              // do nothing
            }
          }
        });
      });
      this.keywords = [].concat(this.keywords); // refresh
      this.$emit("categorySearchItemClick", queryParams, keyword, resetKeyword);
    },
  },
};
</script>

<style lang="scss" scoped>
.categorySearch {
  zoom: 1;
  margin-bottom: 10px;
  &:after {
    content: "020";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  &:last-child {
    margin-bottom: 0;
  }
  > div {
    float: left;
    font-size: 14px;
  }
  .title {
    color: #666;
    padding: 4px 10px;
    min-width: 80px;
  }
  .list {
    width: 90%;
    > span {
      display: inline-block;
      padding: 4px 10px;
      cursor: pointer;
      &.active {
        background-color: #3bc0d0;
        color: #fff;
        border-radius: 20px;
      }
    }
  }
}
</style>
